import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c141aa14"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "image-split__content--wrapper" };
const _hoisted_4 = { class: "d-block text-primary" };
const _hoisted_5 = {
    key: 0,
    class: "line-three"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = ["poster"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["poster"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = { class: "cta" };
const _hoisted_15 = ["href"];
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = ["poster"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["poster"];
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'image_split',
    props: ['d'],
    setup(__props) {
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 760);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 760;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "image-split",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["image-split__content col-lg-6 col-md-6 pe-lg-5", { 'image-split__content--flip': __props.d.alignment == 'text-right' }])
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("h2", {
                                    class: _normalizeClass({
                                        'absolute-brand': __props.d.font_style == 'bold' || (__props.d.absolute_brand_font && __props.d.absolute_brand_font[0] == 'bold'),
                                        'small-title': __props.d.font_style == 'small' || (__props.d.absolute_brand_font && __props.d.absolute_brand_font[0] == 'small'),
                                        'mb-4': (__props.d.font_style == 'small' || (__props.d.absolute_brand_font && __props.d.absolute_brand_font[0] == 'small')) && !__props.d.line_three
                                    })
                                }, [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.d.line_one), 1),
                                    _createTextVNode(" " + _toDisplayString(__props.d.line_two), 1)
                                ], 2),
                                (__props.d.line_three)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.d.line_three), 1))
                                    : _createCommentVNode("", true),
                                (isMobile.value && __props.d.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: __props.d.image,
                                        alt: __props.d.image_alt,
                                        class: "img-fluid mt-4 mb-4",
                                        loading: "lazy"
                                    }, null, 8, _hoisted_6))
                                    : _createCommentVNode("", true),
                                (isMobile.value && __props.d.video_mp4 && __props.d.video_autoplay !== '1')
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 2,
                                        class: "img-fluid mt-4 mb-4",
                                        playsinline: "",
                                        poster: __props.d.video_poster
                                    }, [
                                        _createElementVNode("source", {
                                            src: __props.d.video_mp4,
                                            type: "video/mp4"
                                        }, null, 8, _hoisted_8),
                                        (__props.d.video_webm)
                                            ? (_openBlock(), _createElementBlock("source", {
                                                key: 0,
                                                src: __props.d.video_webm,
                                                type: "video/webm"
                                            }, null, 8, _hoisted_9))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" Your browser does not support this video. ")
                                    ], 8, _hoisted_7))
                                    : _createCommentVNode("", true),
                                (isMobile.value && __props.d.video_mp4 && __props.d.video_autoplay == '1')
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 3,
                                        class: "img-fluid mt-4 mb-4",
                                        autoplay: "",
                                        playsinline: "",
                                        poster: __props.d.video_poster
                                    }, [
                                        _createElementVNode("source", {
                                            src: __props.d.video_mp4,
                                            type: "video/mp4"
                                        }, null, 8, _hoisted_11),
                                        (__props.d.video_webm)
                                            ? (_openBlock(), _createElementBlock("source", {
                                                key: 0,
                                                src: __props.d.video_webm,
                                                type: "video/webm"
                                            }, null, 8, _hoisted_12))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" Your browser does not support this video. ")
                                    ], 8, _hoisted_10))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    class: "image-split__leadin mt-1 mb-5",
                                    innerHTML: __props.d.leadin
                                }, null, 8, _hoisted_13),
                                _createElementVNode("div", _hoisted_14, [
                                    (__props.d.cta_title && __props.d.cta_link)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: __props.d.cta_link,
                                            class: "cta-link"
                                        }, _toDisplayString(__props.d.cta_title), 9, _hoisted_15))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 2),
                        (!isMobile.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["image-split__images col-lg-6 col-md-6 ps-lg-5", { 'image-split__images--flip': __props.d.alignment == 'text-right' }])
                            }, [
                                (__props.d.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: __props.d.image,
                                        alt: __props.d.image_alt,
                                        class: "img-fluid",
                                        loading: "lazy"
                                    }, null, 8, _hoisted_16))
                                    : _createCommentVNode("", true),
                                (__props.d.video_mp4 && __props.d.video_autoplay !== '1')
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 1,
                                        class: "img-fluid",
                                        playsinline: "",
                                        poster: __props.d.video_poster
                                    }, [
                                        _createElementVNode("source", {
                                            src: __props.d.video_mp4,
                                            type: "video/mp4"
                                        }, null, 8, _hoisted_18),
                                        (__props.d.video_webm)
                                            ? (_openBlock(), _createElementBlock("source", {
                                                key: 0,
                                                src: __props.d.video_webm,
                                                type: "video/webm"
                                            }, null, 8, _hoisted_19))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" Your browser does not support this video. ")
                                    ], 8, _hoisted_17))
                                    : _createCommentVNode("", true),
                                (__props.d.video_mp4 && __props.d.video_autoplay == '1')
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 2,
                                        autoplay: "",
                                        class: "img-fluid",
                                        playsinline: "",
                                        poster: __props.d.video_poster
                                    }, [
                                        _createElementVNode("source", {
                                            src: __props.d.video_mp4,
                                            type: "video/mp4"
                                        }, null, 8, _hoisted_21),
                                        (__props.d.video_webm)
                                            ? (_openBlock(), _createElementBlock("source", {
                                                key: 0,
                                                src: __props.d.video_webm,
                                                type: "video/webm"
                                            }, null, 8, _hoisted_22))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" Your browser does not support this video. ")
                                    ], 8, _hoisted_20))
                                    : _createCommentVNode("", true)
                            ], 2))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 4));
        };
    }
});
